[
  "ability:belt-lowcy",
  "ability:burza-iskier",
  "ability:ciecie",
  "ability:ciecie-switu",
  "ability:gniew-ziemi",
  "ability:grot",
  "ability:iskra",
  "ability:lodowa-lanca",
  "ability:lodowa-wlocznia",
  "ability:pierscien-piekiel",
  "ability:pierscien-zaru",
  "ability:rabanie",
  "ability:rozlupanie",
  "ability:rzut-nozami",
  "ability:wachlarz-ostrzy",
  "ability:wicher-stali",
  "ability:wir-burzy",
  "ability:wir-ostrzy",
  "art:branch-atak",
  "art:branch-fortuna",
  "art:branch-obrona",
  "art:hub",
  "art:zone-cmentarz",
  "art:zone-las",
  "art:zone-ruiny",
  "class:arkanista",
  "class:barbarzynca",
  "class:straznik",
  "class:tropiciel",
  "item:ciezka-kusza",
  "item:dwureczny-miecz",
  "item:futrzana-czapa",
  "item:helm-rycerski",
  "item:kapelusz-nekromanty",
  "item:kaptur-zwiadowcy",
  "item:kostna-klinga",
  "item:kostur",
  "item:krotki-miecz",
  "item:krysztalowy-kostur",
  "item:ksiega-zaklec",
  "item:kusza",
  "item:miecz-rycerski",
  "item:noz-do-rzucania",
  "item:otwarta-ksiega",
  "item:pawez",
  "item:peleryna-rycerska",
  "item:plaszcz-cienia",
  "item:plaszcz-gwiazd",
  "item:postrzepiona-peleryna",
  "item:rozdzka",
  "item:runiczny-topor",
  "item:skora-wilka",
  "item:spiczasty-kapelusz",
  "item:sztylet",
  "item:tarcza-barbarzyncy",
  "item:tarcza-kolczasta",
  "item:tarcza-okragla",
  "item:tarcza-z-herbem",
  "item:topor-bojowy",
  "item:topor-poreczny",
  "item:wielki-topor",
  "race:czlowiek",
  "race:elf",
  "race:krasnolud",
  "race:nieumarly",
  "race:ork",
  "race:troll",
  "stat:area",
  "stat:armor",
  "stat:chestRate",
  "stat:cooldown",
  "stat:critChance",
  "stat:damage",
  "stat:goldGain",
  "stat:maxHealth",
  "stat:moveSpeed",
  "stat:pickupRadius",
  "stat:pierce",
  "stat:projectileCount",
  "stat:projectileSpeed",
  "stat:range",
  "stat:regen",
  "stat:xpGain",
  "upgrade:chciwosc",
  "upgrade:kamienna-skora",
  "upgrade:lowca-skarbow",
  "upgrade:madrosc",
  "upgrade:magnes",
  "upgrade:mistrzostwo-broni",
  "upgrade:odnowa-ducha",
  "upgrade:pancerz-przodkow",
  "upgrade:precyzja",
  "upgrade:sila",
  "upgrade:szeroki-zamach",
  "upgrade:szybkie-nogi",
  "upgrade:szybkie-rece",
  "upgrade:wytrwalosc",
  "upgrade:zloty-dotyk"
]
